import { ARTICLES } from '../data/articles';

/**
 * Qué guías enlazar desde la ficha de un producto.
 *
 * Por qué existe: medido en producción, las 13 fichas de producto enlazaban
 * a CERO guías. Son las páginas con más tráfico potencial de compra y el
 * contenido que responde las dudas previas a comprar (qué gramaje necesito,
 * es apto para contacto con alimento, cuánto papel pido al mes) vivía a dos
 * clics de distancia, sin ninguna ruta desde aquí. Para el buscador eso
 * también significa que las guías no recibían enlaces internos desde las
 * páginas más fuertes del sitio.
 *
 * Se resuelve con REGLAS sobre los datos reales del producto (categoría y
 * gramaje), no con una lista curada por ID, por lo mismo que sectors.js:
 * un producto nuevo entra solo al grupo correcto sin editar este archivo.
 * Las reglas usan el mismo criterio de gramaje que ya enseña la guía "cómo
 * elegir el gramaje correcto", así que ficha y guía nunca se contradicen.
 */

const esAntigrasa = (p) => p.category === 'papel_snacks';
const esBolsa = (p) => p.category === 'bolsas_poliseda' || p.category === 'Plásticos';
const gramaje = (p) => p.weight_grams || 0;
const nombre = (p) => (p.name || '').toLowerCase();

// Orden = prioridad. Se muestran las 3 primeras que apliquen, así que las
// reglas específicas van ANTES que las generales: a quien mira papel cebolla
// le sirve más la guía del papel cebolla que la de normativa.
const REGLAS = [
    { slug: 'papel-cebolla-que-es-y-para-que-sirve', aplica: (p) => nombre(p).includes('cebolla') },
    { slug: 'bolsas-de-poliseda-que-son-y-para-que-sirven', aplica: esBolsa },
    { slug: 'papel-antigrasa-restaurantes', aplica: esAntigrasa },
    // El papel ligero es el que se usa para tortillas (16–18 g), el criterio
    // que ya usa la guía de gramajes.
    { slug: 'papel-para-tortillas-al-mayoreo', aplica: (p) => gramaje(p) > 0 && gramaje(p) <= 24 },
    { slug: 'papel-encerado-vs-estraza', aplica: (p) => !esBolsa(p) },
    { slug: 'como-elegir-el-gramaje-correcto', aplica: (p) => gramaje(p) > 0 },
    { slug: 'cuanto-papel-necesita-tu-negocio', aplica: () => true },
    { slug: 'que-es-el-papel-grado-alimenticio', aplica: () => true },
];

/** Hasta `limite` guías relevantes para ese producto. Nunca falla: si una
 *  regla apunta a un slug que ya no existe, esa entrada se descarta. */
export function guiasParaProducto(product, limite = 3) {
    if (!product) return [];
    return REGLAS
        .filter((r) => r.aplica(product))
        .map((r) => ARTICLES.find((a) => a.slug === r.slug))
        .filter(Boolean)
        .slice(0, limite);
}
